var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 20L11.2 20C13.84 20 16 17.8684 16 15.2632L16 14.7368C16 14.4474 15.76 14.2105 15.4667 14.2105L13.3333 14.2105C12.7467 14.2105 12.2667 13.7368 12.2667 13.1579C12.2667 12.5789 12.7467 12.1053 13.3333 12.1053L15.4667 12.1053C15.76 12.1053 16 11.8684 16 11.5789L16 4.73684C16 2.13158 13.84 -9.44166e-08 11.2 -2.09815e-07L9.6 -2.79753e-07C9.6 -2.79753e-07 7.28533 -3.80929e-07 6.4 -4.19629e-07L4.8 -4.89568e-07C2.16 -6.04966e-07 8.605e-07 2.13158 7.4662e-07 4.73684L4.47542e-07 11.5789C4.34889e-07 11.8684 0.24 12.1053 0.533334 12.1053L2.66667 12.1053C3.25333 12.1053 3.73333 12.5789 3.73333 13.1579C3.73333 13.7368 3.25333 14.2105 2.66667 14.2105L0.533334 14.2105C0.24 14.2105 3.2216e-07 14.4474 3.09506e-07 14.7368L2.865e-07 15.2632C1.72621e-07 17.8684 2.16 20 4.8 20L6.4 20C7.28533 20 9.6 20 9.6 20ZM6.4 14.2105C5.81333 14.2105 5.33333 13.7368 5.33333 13.1579C5.33333 12.5789 5.81333 12.1053 6.4 12.1053L9.6 12.1053C10.1867 12.1053 10.6667 12.5789 10.6667 13.1579C10.6667 13.7368 10.1867 14.2105 9.6 14.2105L6.4 14.2105Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPin);
export default __webpack_public_path__ + "static/media/paper-pin.f936150e729f6517e2296d249aae542c.svg";
export { ForwardRef as ReactComponent };